export default {
  "region.Hokkaido": "北海道",

  "region.Northeast": "東北",
  "perfecture.Aomori": "青森県",
  "perfecture.Iwate": "岩手県",
  "perfecture.Miyagi": "宮城県",
  "perfecture.Akita": "秋田県",
  "perfecture.Yamagata": "山形県",
  "perfecture.Fukushima": "福島県",

  "region.Kanto": "関東",
  "prefecture.Ibaraki": "茨城県",
  "prefecture.Tochigi": "栃木県",
  "prefecture.Gunma": "群馬県",
  "prefecture.Saitama": "埼玉県",
  "prefecture.Chiba": "千葉県",
  "prefecture.Tokyo": "東京都",
  "prefecture.Kanagawa": "神奈川県",

  "region.central": "中部",
  "prefecture.Niigata": "新潟県",
  "prefecture.Toyama": "富山県",
  "prefecture.Ishikawa": "石川県",
  "prefecture.Fukui": "福井県",
  "prefecture.Yamanashi": "山梨県",
  "prefecture.Nagano": "長野県",
  "prefecture.Gifu": "岐阜県",
  "prefecture.Shizuoka": "静岡県",
  "prefecture.Aichi": "愛知県",

  "region.Kinki": "近畿",
  "prefecture.Mie": "三重県",
  "prefecture.Shiga": "滋賀県",
  "prefecture.Kyoto": "京都府",
  "prefecture.Osaka": "大阪府",
  "prefecture.Hyogo": "兵庫県",
  "prefecture.Nara": "奈良県",
  "prefecture.Wakayama": "和歌山県",

  "region.China": "中国",
  "prefecture.Tottori": "鳥取県",
  "prefecture.Shimane": "島根県",
  "prefecture.Okayama": "岡山県",
  "prefecture.Hiroshima": "広島県",
  "prefecture.Yamaguchi": "山口県",

  "region.Shikoku": "四国",
  "prefecture.Tokushima": "徳島県",
  "prefecture.Kagawa": "香川県",
  "prefecture.Ehime": "愛媛県",
  "prefecture.Kochi": "高知県",

  "region.KyushuOkinawa": "九州・沖縄",
  "prefecture.Fukuoka": "福岡県",
  "prefecture.Saga": "佐賀県",
  "prefecture.Nagasaki": "長崎県",
  "prefecture.Kumamoto": "熊本県",
  "prefecture.Oita": "大分県",
  "prefecture.Miyazaki": "宮崎県",
  "prefecture.Kagoshima": "鹿児島県",
  "prefecture.Okinawa": "沖縄県",
};